import { render, staticRenderFns } from "./reject_reasons.vue?vue&type=template&id=7c91f7ab&scoped=true&"
import script from "./reject_reasons.vue?vue&type=script&lang=js&"
export * from "./reject_reasons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c91f7ab",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/brisk/brisk-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7c91f7ab')) {
      api.createRecord('7c91f7ab', component.options)
    } else {
      api.reload('7c91f7ab', component.options)
    }
    module.hot.accept("./reject_reasons.vue?vue&type=template&id=7c91f7ab&scoped=true&", function () {
      api.rerender('7c91f7ab', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/captains_registration_requests/actions/modals/reject_reasons.vue"
export default component.exports